import React from 'react';
import { Box } from '@mui/material';
import PropertyCard from '../../../../../components/PropertyCard/PropertyCard';
import { bookingImageGalleryStyles } from './BookingImageGallery.styles';

const BookingImageGallery = ({ imagesStartAnimation = false, properties = [] }) => {
  // Default properties if none provided
  const defaultProperties = [
    { image: '', title: '', subtitle: '', price: '', currency: '', chips: [] },
    { image: '', title: '', subtitle: '', price: '', currency: '', chips: [] },
    { image: '', title: '', subtitle: '', price: '', currency: '', chips: [] },
    { image: '', title: '', subtitle: '', price: '', currency: '', chips: [] },
    { image: '', title: '', subtitle: '', price: '', currency: '', chips: [] },
  ];
  
  const cardsData = properties.length > 0 ? properties : defaultProperties;

  return (
    <Box sx={bookingImageGalleryStyles.container}>
      <Box sx={bookingImageGalleryStyles.gradientBackground} />
      <Box sx={bookingImageGalleryStyles.imageContainer}>
        {/* 1st card: -13deg rotation */}
        <Box
          sx={{
            ...bookingImageGalleryStyles.cardWrapper,
            ...bookingImageGalleryStyles.card1,
            ...bookingImageGalleryStyles.slideUpFromBottom(imagesStartAnimation, 0, '-13deg', 0),
          }}
        >
          <PropertyCard
            image={cardsData[0]?.image || ''}
            title={cardsData[0]?.title || ''}
            subtitle={cardsData[0]?.subtitle || ''}
            price={cardsData[0]?.price || ''}
            currency={cardsData[0]?.currency || ''}
            chips={cardsData[0]?.chips || []}
          />
        </Box>
        {/* 2nd card: -5deg rotation */}
        <Box
          sx={{
            ...bookingImageGalleryStyles.cardWrapper,
            ...bookingImageGalleryStyles.card2,
            ...bookingImageGalleryStyles.slideUpFromBottom(imagesStartAnimation, 0.1, '-5deg', 1),
          }}
        >
          <PropertyCard
            image={cardsData[1]?.image || ''}
            title={cardsData[1]?.title || ''}
            subtitle={cardsData[1]?.subtitle || ''}
            price={cardsData[1]?.price || ''}
            currency={cardsData[1]?.currency || ''}
            chips={cardsData[1]?.chips || []}
            buildingIcon={cardsData[1]?.buildingIcon}
          />
        </Box>
        {/* 3rd card (middle): no rotation */}
        <Box
          sx={{
            ...bookingImageGalleryStyles.cardWrapper,
            ...bookingImageGalleryStyles.card3,
            ...bookingImageGalleryStyles.slideUpFromBottom(imagesStartAnimation, 0.2, '0deg', 2),
          }}
        >
          <PropertyCard
            image={cardsData[2]?.image || ''}
            title={cardsData[2]?.title || ''}
            subtitle={cardsData[2]?.subtitle || ''}
            price={cardsData[2]?.price || ''}
            currency={cardsData[2]?.currency || ''}
            chips={cardsData[2]?.chips || []}
            buildingIcon={cardsData[2]?.buildingIcon}
          />
        </Box>
        {/* 4th card: 5deg rotation */}
        <Box
          sx={{
            ...bookingImageGalleryStyles.cardWrapper,
            ...bookingImageGalleryStyles.card4,
            ...bookingImageGalleryStyles.slideUpFromBottom(imagesStartAnimation, 0.3, '5deg', 3),
          }}
        >
          <PropertyCard
            image={cardsData[3]?.image || ''}
            title={cardsData[3]?.title || ''}
            subtitle={cardsData[3]?.subtitle || ''}
            price={cardsData[3]?.price || ''}
            currency={cardsData[3]?.currency || ''}
            chips={cardsData[3]?.chips || []}
            buildingIcon={cardsData[3]?.buildingIcon}
          />
        </Box>
        {/* 5th card: 13deg rotation */}
        <Box
          sx={{
            ...bookingImageGalleryStyles.cardWrapper,
            ...bookingImageGalleryStyles.card5,
            ...bookingImageGalleryStyles.slideUpFromBottom(imagesStartAnimation, 0.4, '13deg', 4),
          }}
        >
          <PropertyCard
            image={cardsData[4]?.image || ''}
            title={cardsData[4]?.title || ''}
            subtitle={cardsData[4]?.subtitle || ''}
            price={cardsData[4]?.price || ''}
            currency={cardsData[4]?.currency || ''}
            chips={cardsData[4]?.chips || []}
            buildingIcon={cardsData[4]?.buildingIcon}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BookingImageGallery;
